import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { EntityDriverLinkContainerModel} from '../../../../../../models/aggregates/erp/entity/entity-driver-link-container.model';
import {
  BaseApiTemplateService,
  Core2Config,
} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class EntityDriverLinkService extends BaseApiTemplateService<EntityDriverLinkContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-driver-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-driver-links/'+ Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
}